<template>
  <div>
    <topbar v-if="!fullscreen" />
    <sidebar v-if="!hideSidebar && !fullscreen" />
    <main
      class="router-view"
      :class="{header: $route.meta.header, footer: $route.meta.footer, fullscreen: $route.meta.fullscreen, noSidebar: hideSidebar, masteryFooter: $route.meta.masteryFooter, masteryHeader: $route.meta.masteryHeader}"
    >
      <router-view v-scrollable />
    </main>
    <template v-if="!fullscreen">
      <notify />
      <mobile-menu />
      <template v-if="user">
        <upsell-popout v-if="isAse" />
        <preferred-po-modal v-else-if="preferredPoEnabled" />
        <upsell-modal v-else />
        <modal-container />
      </template>
    </template>
    <attachment-modal />
  </div>
</template>

<script>
import MobileMenu from '@components/singletons/mobile-menu';
import ModalContainer from '@components/modals/modal-container';
import Notify from '@components/singletons/notify';
import PreferredPoModal from '@components/purchasing/preferredPoModal';
import Sidebar from '@components/singletons/sidebar';
import Topbar from '@components/singletons/topbar';
import UpsellModal from '@components/purchasing/upsell-modal';
import UpsellPopout from '@components/purchasing/upsell-popout';

import { asyncImport } from '@/utils';
const AttachmentModal = () => asyncImport(import(/* webpackChunkName: "attachmentModal" */ '@components/attachments/attachment-modal'));

export default {
  components: { AttachmentModal, MobileMenu, ModalContainer, Notify, Sidebar, Topbar, PreferredPoModal, UpsellModal, UpsellPopout },
  computed: {
    fullscreen() {
      return this.$route.meta.fullscreen;
    },
    hideSidebar() {
      return this.$route.meta.sidebar === 'hide' || (this.$route.meta.sidebar === 'hideUnlessAuthenticated' && !this.user);
    },
    isAse() {
      return this.$store.getters['certifications/certificationsList'].length > 0;
    },
    preferredPoEnabled() {
      const classification = this.$store.getters['session/classification'];
      return classification && classification.preferredPurchaseOrderId;
    },
    user() {
      return this.$store.getters['session/currentUser'];
    },
  },
};
</script>

<style lang='scss' scoped>
  .router-view {
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    height: calc(100% - #{rem-calc(48)});
    left: rem-calc(220);
    position: absolute;
    right: 0;
    top: rem-calc(48);

    @include breakpoint(small) {
      height: calc(100% - #{rem-calc(72)});
      left: 0;
      top: rem-calc(72);
    }

    > *:first-child  {
      bottom: 0;
      box-sizing: border-box;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding: rem-calc(32) rem-calc(48);
      position: absolute;
      top: 0;
      width: 100%;

      @include breakpoint(small) {
        padding: rem-calc(16);
      }
    }

    &.header {
      > *:first-child {
        height: calc(100% - #{rem-calc(109)});
        top: rem-calc(109);
      }

      &.masteryHeader {
        > *:first-child {
          padding-top: 0;
          top: rem-calc(45);
        }
      }
    }

    &.footer {
      > *:first-child {
        bottom: rem-calc(64);
        height: calc(100% - #{rem-calc(64)});
      }

      &.masteryFooter {
        > *:first-child {
          bottom: rem-calc(44);
        }
      }
    }

    &.header.footer {
      > *:first-child {
        height: calc(100% - #{rem-calc(109)} - #{rem-calc(64)});
      }
    }

    &.header.masteryFooter {
      > *:first-child {
        height: calc(100% - #{rem-calc(109)} - #{rem-calc(44)});
      }
    }

    &.masteryHeader.masteryFooter {
      > *:first-child {
        height: calc(100% - #{rem-calc(45)} - #{rem-calc(44)});
      }
    }

    &.fullscreen {
      height: 100%;
      left: 0;
      top: 0;
    }

    &.noSidebar {
      left: 0;
    }
  }
</style>
